import React from "react";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@jem-open/jem-ui";

export interface MoveRosterDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  rosterName: string | null;
  sourceSiteName: string;
  destinationSites: { id: string; label: string }[];
  destination: string;
  onDestinationChange: (id: string) => void;
  onConfirm: () => void;
}

/**
 * Move a Roster to another Site. Shared between the Sites & Regions overview and
 * the per-Site deep config page — both pass a flat destination Site list.
 */
export const MoveRosterDialog: React.FC<MoveRosterDialogProps> = ({
  open,
  onOpenChange,
  rosterName,
  sourceSiteName,
  destinationSites,
  destination,
  onDestinationChange,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Move Roster to another Site</DialogTitle>
        <DialogDescription>
          {rosterName && (
            <>
              Move <strong>{rosterName}</strong> away from{" "}
              <strong>{sourceSiteName}</strong>. The Roster starts fresh at the
              destination — all settings reset to the destination Site&apos;s
              defaults, and any custom values are cleared. You can set new
              custom values after the move.
            </>
          )}
        </DialogDescription>
      </DialogHeader>
      <div className="mt-md space-y-xxs">
        <Label>Destination Site</Label>
        <Select value={destination} onValueChange={onDestinationChange}>
          <SelectTrigger>
            <SelectValue placeholder="Select a Site" />
          </SelectTrigger>
          <SelectContent>
            {destinationSites.map((s) => (
              <SelectItem key={s.id} value={s.id}>
                {s.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button variant="default" disabled={!destination} onClick={onConfirm}>
          Move Roster
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export default MoveRosterDialog;
